// extracted by mini-css-extract-plugin
module.exports = {"blogCards":"BlogCards-module--blogCards--31KPs","blogCard":"BlogCards-module--blogCard--5PK1d","date":"BlogCards-module--date--37BwC"};